import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import classes from 'components/CheckIn/CheckInVehiclePlacement/CheckInVehiclePlacement.module.scss';
import CheckInTextField from 'components/CheckIn/CheckInTextField/CheckInTextField';
import VehicleDriver from 'assets/svg/vehicle_driver.svg';
import VehiclePassenger from 'assets/svg/vehicle_passenger.svg';
import VehicleBackLeft from 'assets/svg/vehicle_back_left.svg';
import VehicleBackRight from 'assets/svg/vehicle_back_right.svg';
import VehicleTrunk from 'assets/svg/vehicle_trunk.svg';
import VehicleActiveDriver from 'assets/svg/vehicle_active_driver.svg';
import VehicleActivePassenger from 'assets/svg/vehicle_active_passenger.svg';
import VehicleActiveBackLeft from 'assets/svg/vehicle_active_back_left.svg';
import VehicleActiveBackRight from 'assets/svg/vehicle_active_back_right.svg';
import VehicleActiveTrunk from 'assets/svg/vehicle_active_trunk.svg';
import Constants from 'config/constants';

export default function CheckInVehiclePlacement(props) {

    const parkingLocations = [
        'Designated Pickup Spot',
        'Other'
    ];

    const vehiclePlacements = [
        {text: 'Driver', value: 'Driver', css: 'Driver', src: VehicleDriver, activeSrc: VehicleActiveDriver},
        {text: 'Passenger', value: 'Passenger', css: 'Passenger', src: VehiclePassenger, activeSrc: VehicleActivePassenger},
        {text: 'Back Left', value: 'Back Left', css: 'BackLeft', src: VehicleBackLeft, activeSrc: VehicleActiveBackLeft},
        {text: 'Back Right', value: 'Back Right', css: 'BackRight', src: VehicleBackRight, activeSrc: VehicleActiveBackRight},
        {text: 'Trunk', value: 'Trunk', src: VehicleTrunk, css: 'Trunk', activeSrc: VehicleActiveTrunk}
    ];

    return (
        <div className={classes.Container}>
            <p className={classes.CheckInVehicleTitle}>Where are you parked?</p>
            <ToggleButtonGroup
                exclusive value={props.vehiclePlacement}
                onChange={(event, newState) => props.setLocation(newState)}
                className={classes.CheckInVehicleContainer}
            >
                {parkingLocations.map((parkingLocation) => (
                    <ToggleButton
                        key={parkingLocation}
                        value={parkingLocation}
                        variant="outlined"
                        className={props.location === parkingLocation ? classes.ParkingLocationToggleBtnActive : classes.ParkingLocationToggleBtn}
                    >
                        <div className={classes.ParkingLocationBtnText}>{parkingLocation}</div>
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            {props.location &&
                <CheckInTextField value={props.locationText}
                                  labels={props.location === 'Other' ?
                                      Constants.CHECK_IN_CURBSIDE_PARKING_OTHER_TEXTFIELD_LABELS : Constants.CHECK_IN_CURBSIDE_PARKING_SPOT_TEXTFIELD_LABELS}
                                  setValue={props.setLocationText}
                />
            }
            <p className={classes.CheckInVehicleTitle}>Where do you want your order?</p>
            <ToggleButtonGroup
                exclusive value={props.vehiclePlacement}
                onChange={(event, newState) => props.setVehiclePlacement(newState)}
                className={classes.CheckInVehicleContainer}
            >
                {vehiclePlacements.map(placement => (
                    <ToggleButton
                        key={placement.value}
                        value={placement.value}
                        className={placement.value === props.vehiclePlacement ? classes[`${placement.css}Active`] : classes[placement.css]}
                    >
                        <img src={placement.value === props.vehiclePlacement ? placement.activeSrc : placement.src}
                             alt={placement.text}/>
                        <div className={classes.CheckInVehicleBtnText}>{placement.text}</div>
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </div>
    );
}
